import { render, staticRenderFns } from "./table-sale.vue?vue&type=template&id=202ca402&scoped=true"
import script from "./table-sale.vue?vue&type=script&lang=js"
export * from "./table-sale.vue?vue&type=script&lang=js"
import style0 from "./table-sale.vue?vue&type=style&index=0&id=202ca402&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ca402",
  null
  
)

export default component.exports